/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 19:38:01
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 14:13:39
 * @name: 主页头部
 * @Description: 主页头部
 * @FilePath: \preSaleNafterSaleBackstage\src\store\modules\indexHead.js
 * @Author: DESKTOP-1QU67QM
 */

const state = {
  tabs: [
    //导航栏tabs
    {
      label: "通讯录",
      path: "/index/mailList",
      children: [
        {
          label: "通讯录",
          path: "/index/mailList/mailList",
        },
      ],
    },
    {
      label: "琴行管理",
      path: "/index/pianoCompanyManage",
      children: [
        {
          label: "琴行管理",
          path: "/index/pianoCompanyManage/pianoCompanyManage",
        },
      ],
    },
    {
      label: "审批管理",
      path: "/index/approvalManage",
      children: [
        // {
        //   label: "折扣审批",
        //   path: "/index/approvalManage/discountApprovalManage",
        // },
        // {
        //   label: "延期审批",
        //   path: "/index/approvalManage/delayApprovalManage",
        // },
        // {
        //   label: "售后审批",
        //   path: "/index/approvalManage/afterSalesApprovalManage",
        // },
        {
          label: "工作流管理",
          path: "/index/approvalManage/flowManage",
        },
      ],
    },
    {
      label: "工单管理",
      path: "/index/issueManage",
      children: [
        {
          label: "订单管理",
          path: "/index/issueManage/issueListManage",
        },
      ],
    },
    {
      label: "订单管理",
      path: "/index/approvalListManage",
      children: [
        {
          label: "订单管理",
          path: "/index/approvalListManage/orderApprovalListManage",
        },
      ],
    },
    {
      label: "商品管理",
      path: "/index/goodsManage",
      children: [   
        {
          label: "商品管理",
          path: "/index/goodsManage/waresGoodsManage",
        },
        {
          label: "品牌系列型号管理",
          path: "/index/goodsManage/modelGoodsManage",
        },
      ],
    },
    {
      label: "设置",
      path: "/index/setting",
      children: [
        {
          label: "设置",
          path: "/index/setting/setting",
        },
      ],
    },
    {
      label: "权限管理",
      path: "/index/jurisdiction",
      children: [
        {
          label: "后台管理",
          path: "/index/jurisdiction/person",
        },
        {
          label: "角色管理",
          path: "/index/jurisdiction/role",
        },
      ],
    },
  ],
}

export default {
  namespaced: true,
  state,
}